document.addEventListener('DOMContentLoaded', function() {
  // Mobile accordion toggle only
  window.toggleFeatureAccordion = function(element) {
    // Only run on mobile
    if (window.innerWidth >= 750) return;

    const card = element.closest('.cfs-card');
    if (!card) return;

    const grid = card.closest('.cfs-grid');
    if (!grid) return;

    // Read layout from data attribute
    const layout = grid.dataset.mobileLayout || 'accordion';
    if (layout !== 'accordion') {
      // In slider mode do nothing
      return;
    }

    const wasActive = card.classList.contains('active');

    // Close all other cards
    grid.querySelectorAll('.cfs-card').forEach(function(c) {
      if (c !== card) {
        c.classList.remove('active');
      }
    });

    // Toggle current
    if (!wasActive) {
      card.classList.add('active');
    } else {
      card.classList.remove('active');
    }
  };

  // Reset active when jumping to desktop
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 750) {
      document.querySelectorAll('.cfs-card.active').forEach(function(card) {
        card.classList.remove('active');
      });
    }
  });
});
